<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <el-select class="select-primary" size="large" v-model="selectedCalendar">
            <el-option class="select-primary" value="All" :label="$t('message.All')"></el-option>
            <el-option class="select-primary" :value="calendar.id" :label="getCalanderNameTranslation(calendar.name)" v-for="calendar in calendarList" :key="calendar.id"></el-option>
          </el-select>
        </div>
        <div class="col-6">
          <el-select class="select-primary" size="large" v-model="selectedView">
            <el-option class="select-primary" value="day" :label="$t('message.Daily')"></el-option>
            <el-option class="select-primary" value="week" :label="$t('message.Weekly')"></el-option>
            <el-option class="select-primary" value="month" :label="$t('message.Monthly')"></el-option>
          </el-select>
        </div>
        <div class="col-3">
          <n-button type="primary" round @click.native="setRange('today')">{{
            $t("message.Today")
          }}</n-button>
        </div>
        <div class="col-2">
          <n-button type="primary" round icon @click.native="setRange('prev')">
            <i class="now-ui-icons arrows-1_minimal-left"></i>
          </n-button>
        </div>
        <div class="col-5 pr-0" style="line-height: 68px">{{ range }}</div>
        <div class="col-2">
          <n-button type="primary" round icon @click.native="setRange('next')">
            <i class="now-ui-icons arrows-1_minimal-right"></i>
          </n-button>
        </div>
        <div class="col-12">
          <i class="text-muted" style="font-size: smaller">{{$t('message.Your timezone:')}}{{ timezone }}</i>
        </div>
      </div>
    </div>
    <div v-show="SHOW_AVAILABILITY_MODAL" id="add-availability-modal">
      <div class="container">
        <card>
          <h4 class="title title-up" style="text-align:center;"> {{$t('message.Add availability')}}</h4>
          <div class="row">

            <div class="col-2">
              <span style="white-space: nowrap; line-height: 4em;">{{$t('message.Type')}} </span>
            </div>
            <div class="col-10">
              <el-select class="select-primary" placeholder="Type" v-model="availabilityType" :class="!availabilityType ? 'placeholder' : ''" style="width: 16em;margin-left: 0.5em;">
                <el-option class="select-danger" value="Available" :label="getCalanderNameTranslation('Available')"></el-option>
                <el-option class="select-danger" value="Available-TeleConsult" :label="getCalanderNameTranslation('Available-TeleConsult')"></el-option>
                <el-option class="select-danger" value="Available-InPerson" :label="getCalanderNameTranslation('Available-InPerson')"></el-option>
              </el-select>

            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <div class="row">
                <div class="col-2">
                  <span style="white-space: nowrap; line-height: 3em;">{{$t('message.Start')}}</span>
                </div>
                <div class="col-10">
                  <div class="tui-datepicker-input tui-datetime-input tui-has-focus" style="border-radius: 10em; height: 2.9em; border-color: rgb(227, 227, 227);margin-left: 0.5em;">
                    <input type="text" id="start-date" aria-label="Date-Time" style="border-radius: 10em; padding-top: 0.9em; padding-bottom: 0.9em; padding-left: 1.9em; padding-right: 1.9em;" :readonly="true" />
                    <span class="tui-ico-date"></span>
                  </div>
                  <div id="start-wrapper" style="margin-top: -1px"></div>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <div class="row">
                <div class="col-2">
                  <span style="white-space: nowrap; line-height: 3em;">{{$t('message.End')}}</span>
                </div>
                <div class="col-10">
                  <div class="tui-datepicker-input tui-datetime-input tui-has-focus" style="border-radius: 10em; height: 2.9em; border-color: rgb(227, 227, 227);margin-left: 0.5em;">
                    <input type="text" id="end-date" aria-label="Date-Time" style="border-radius: 10em; padding-top: 0.9em; padding-bottom: 0.9em; padding-left: 1.9em; padding-right: 1.9em;" :readonly="true" />
                    <span class="tui-ico-date"></span>
                  </div>
                  <div id="end-wrapper" style="margin-top: -1px"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: -10px;">
            <div class="col-2">
              <span style="white-space: nowrap; line-height: 4em;">{{$t('message.Repeat')}}</span>
            </div>
            <div class="col-10">
              <el-select class="select-primary" :placeholder="$t('message.Weekly')" v-model="frequency" :class="!frequency ? 'placeholder' : ''" style="width: 16em;margin-left: 0.5em;">
                <el-option class="select-danger" value="NEVER" :label="$t('message.Never')"></el-option>
                <el-option class="select-danger" value="DAILY" :label="$t('message.Daily')"></el-option>
                <el-option class="select-danger" value="WEEKLY" :label="$t('message.Weekly')"></el-option>
              </el-select>
            </div>
          </div>

          <div class="row" style="margin-top: -10px;" v-if="availabilityLocation && availabilityLocation.name && availabilityType != 'Available-TeleConsult'">
            <div class="col-2">
              <span style="white-space: nowrap; line-height: 4em;">{{$t('message.Location')}}</span>
            </div>
            <div class="col-10">
              <el-select class="select-primary" placeholder="Type" v-model="availabilityLocation.name" :class="!availabilityLocation  ? 'placeholder' : ''" style="width: 16em;margin-left: 0.5em;">
                <el-option v-for="location in endpointLocations" :key="location._id" class="select-danger" :value="location.name" :label="location.name" @click.native="setAvailabilityLocation(location._id,location.name)"></el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-2" v-if="frequency && frequency != 'NEVER'">
              <span style="white-space: nowrap;">{{$t('message.Repeat')}}</span> <br />
              <span style="white-space: nowrap;">{{$t('message.every')}}</span>
            </div>
            <div class="col-6" v-if="frequency && frequency != 'NEVER'">
              <input type="number" v-model="repeatEvery" class="form-control" />
            </div>
            <div class="col-2">
              <span style="white-space: nowrap; line-height: 3em;" v-if="frequency == 'DAILY'">{{$t('message.Day(s)')}}</span>
              <span style="white-space: nowrap; line-height: 3em;" v-if="frequency == 'WEEKLY'">{{$t('message.Week(s)')}}</span>
            </div>
          </div>
          <br />

          <div class="row">
            <div class="col-12" v-if="frequency && frequency == 'WEEKLY'">
              <span style="white-space: nowrap;">{{$t('message.Repeat on')}}</span>
              <div style="margin-bottom: 10px">
                <n-button :type="daysOfWeek.includes('SU') ? 'primary' : 'default'" round icon @click.native="selectDay('SU')" style="margin-right: 10px">
                  S
                </n-button>
                <n-button :type="daysOfWeek.includes('MO') ? 'primary' : 'default'" round icon @click.native="selectDay('MO')" style="margin-right: 10px">
                  M
                </n-button>
                <n-button :type="daysOfWeek.includes('TU') ? 'primary' : 'default'" round icon @click.native="selectDay('TU')" style="margin-right: 10px">
                  T
                </n-button>
                <n-button :type="daysOfWeek.includes('WE') ? 'primary' : 'default'" round icon @click.native="selectDay('WE')" style="margin-right: 10px">
                  W
                </n-button>
                <n-button :type="daysOfWeek.includes('TH') ? 'primary' : 'default'" round icon @click.native="selectDay('TH')" style="margin-right: 10px">
                  T
                </n-button>
                <n-button :type="daysOfWeek.includes('FR') ? 'primary' : 'default'" round icon @click.native="selectDay('FR')" style="margin-right: 10px">
                  F
                </n-button>
                <n-button :type="daysOfWeek.includes('SA') ? 'primary' : 'default'" round icon @click.native="selectDay('SA')" style="margin-right: 10px">
                  S
                </n-button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-center">
              <n-button @click.native="SHOW_AVAILABILITY_MODAL = false" round>{{$t('message.Close')}}</n-button>
            </div>
            <div class="col-6 text-center">
              <n-button round type="primary" @click.native="saveAvailability()">{{$t('message.Save')}}</n-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <vue-tuicalendar v-if="calendarOptions" ref="calendar" :options="calendarOptions" :schedules="schedules"></vue-tuicalendar>

    <n-button type="primary" round icon @click.native="openAvailibilityModal()" style="position: fixed; inset-inline-end: 10px; bottom: 10px" size="lg">
      <i class="now-ui-icons ui-1_simple-add"></i>
    </n-button>

  </div>
</template>
<script>
import "chance";
import moment from "moment";
import momentTimezone from "moment-timezone";
import DatePicker from "tui-date-picker";
import tuiCalendar from "tui-calendar";
import { RRule } from "rrule";

export default {
  name: "my-availability",

  data() {
    return {
      scheduleData: null,
      schedules: [],
      range: "",
      selectedCalendar: "All",
      selectedView: "day",
      SHOW_AVAILABILITY_MODAL: false,
      frequency: null,
      availabilityType: "Available",
      availabilitySaveMode: "create",
      availabilityScheduleData: null,
      repeatEvery: null,
      daysOfWeek: null,
      allDay: false,
      workingHours: {
        start: 0,
        end: 24,
      },
      calendarList: [
        {
          id: "Available",
          name: "Available",
          checked: true,
          color: "#ffffff",
          bgColor: "#18ce0f",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "Available-TeleConsult",
          name: "Available-TeleConsult",
          checked: true,
          color: "#ffffff",
          bgColor: "#c59edb",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "Available-InPerson",
          name: "Available-InPerson",
          checked: true,
          color: "#ffffff",
          bgColor: "#edac09",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "AppointmentCreated",
          name: "Upcoming",
          checked: true,
          color: "#ffffff",
          bgColor: "#4287f5",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Created", "Assigned"],
        },
        {
          id: "AppointmentOngoing",
          name: "Ongoing",
          checked: true,
          color: "#ffffff",
          bgColor: "#fae339",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["InProgress", "Postponed"],
        },
        {
          id: "AppointmentCompleted",
          name: "Completed",
          checked: true,
          color: "#ffffff",
          bgColor: "#a1a09d",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Completed", "Closed"],
        },
        {
          id: "AppointmentCancelled",
          name: "Cancelled",
          checked: true,
          color: "#ffffff",
          bgColor: "#f20c0c",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Cancelled", "Declined"],
        },
      ],
      calendarOptions: null,
      apptDateDetails: {
        dateStart: 0,
        dateEnd: 0,
      },
      availabilityLocation: null,
      endpointLocations: [],
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    timezone() {
      return (
        momentTimezone.tz.guess() +
        " (GMT" +
        momentTimezone.tz(momentTimezone.tz.guess()).format("Z") +
        ")"
      );
    },
    settings() {
      return this.$store.state.settings;
    },
  },

  async mounted() {
    let that = this;
    this.workingHours = this.settings.workingHours;

    // Calendar options
    this.calendarOptions = {
      template: {
        timegridDisplayPrimayTime: function (time) {
          let meridian = "am";
          if (time.hour > 12) {
            time.hour = time.hour - 12;
            meridian = "pm";
          }

          if (time.hour == 12) {
            meridian = "pm";
          }
          return time.hour + " " + meridian;
        },
        allday: function (schedule) {
          return that.getTimeTemplate(schedule, true);
        },
        time: function (schedule) {
          return that.getTimeTemplate(schedule, false);
        },
      },
      defaultView: "week",
      taskView: false,
      useCreationPopup: false,
      useDetailPopup: true,
      calendars: [
        {
          id: "Available",
          name: "Available",
          checked: true,
          color: "#ffffff",
          bgColor: "#18ce0f",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "Available-TeleConsult",
          name: "Available-TeleConsult",
          checked: true,
          color: "#ffffff",
          bgColor: "#c59edb",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "Available-InPerson",
          name: "Available-InPerson",
          checked: true,
          color: "#ffffff",
          bgColor: "#edac09",
          borderColor: "#bbdc00",
          dragBgColor: "#bbdc00",
          status: [],
        },
        {
          id: "AppointmentCreated",
          name: "Upcoming",
          checked: true,
          color: "#ffffff",
          bgColor: "#4287f5",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Created", "Assigned"],
        },
        {
          id: "AppointmentOngoing",
          name: "Ongoing",
          checked: true,
          color: "#ffffff",
          bgColor: "#fae339",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["InProgress", "Postponed"],
        },
        {
          id: "AppointmentCompleted",
          name: "Completed",
          checked: true,
          color: "#ffffff",
          bgColor: "#a1a09d",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Completed", "Closed"],
        },
        {
          id: "AppointmentCancelled",
          name: "Cancelled",
          checked: true,
          color: "#ffffff",
          bgColor: "#f20c0c",
          borderColor: "#4287f5",
          dragBgColor: "#4287f5",
          status: ["Cancelled", "Declined"],
        },
      ],
      month: {
        daynames: [
          this.$t("message.Sun"),
          this.$t("message.Mon"),
          this.$t("message.Tue"),
          this.$t("message.Wed"),
          this.$t("message.Thu"),
          this.$t("message.Fri"),
          this.$t("message.Sat"),
        ],
        startDayOfWeek: 1,
        hourStart: this.workingHours.start,
        hourEnd: this.workingHours.end,
      },
      week: {
        daynames: [
          this.$t("message.Sun"),
          this.$t("message.Mon"),
          this.$t("message.Tue"),
          this.$t("message.Wed"),
          this.$t("message.Thu"),
          this.$t("message.Fri"),
          this.$t("message.Sat"),
        ],
        startDayOfWeek: 1,
        hourStart: this.workingHours.start,
        hourEnd: this.workingHours.end,
      },
    };

    if (this.user.endpoints && this.user.endpoints.length > 0) {
      for (let endpoint of this.user.endpoints) {
        try {
          let res = await that.$store.dispatch("getEndpoint", endpoint.name);
          if (res.location) {
            if (!this.availabilityLocation) {
              this.availabilityLocation = {
                id: res.location._id,
                name: res.location.name,
              };
            }
            this.endpointLocations.push(res.location);
          }
        } catch (e) {
          console.error(e);
        }
      }
    }

    console.log(this.endpointLocations);

    setTimeout(() => {
      this.initCalendar();
    }, 1000);
  },

  methods: {
    initCalendar() {
      let that = this;
      this.$refs.calendar.fireMethod("changeView", this.selectedView, true);

      //Create schedule
      this.$refs.calendar.registerEvent("beforeCreateSchedule", (e) => {
        if (!this.SHOW_AVAILABILITY_MODAL) {
          let scheduleData = {
            schedule: {
              start: e.start._date,
              end: e.end._date,
              isAllDay: e.isAllDay,
            },
          };
          this.openAvailibilityModal("create", scheduleData);
        }
      });

      //Delete schedule
      this.$refs.calendar.registerEvent("beforeDeleteSchedule", async (e) => {
        let schedule = this.scheduleData.filter((data) => {
          return data.slotId == e.schedule.id;
        });

        window.$(document).one("click", ".delete", async function () {
          try {
            await that.$store.dispatch("deleteSlot", e.schedule.id);
            swal.fire({
              type: "success",
              title: that.$t("message.Slot deleted successfully!"),
              timer: 3000,
            });
            that.getSlots();
          } catch (e) {
            console.log(e);
            swal.fire({
              type: "error",
              title: that.$t("message.Error deleting slot!"),
              timer: 5000,
            });
          }
        });
        window.$(document).one("click", ".delete-series", async function () {
          swal.close();

          try {
            await that.$store.dispatch(
              "deleteRecurringSlots",
              schedule[0].seriesId
            );
            swal.fire({
              type: "success",
              title: that.$t("message.Slot deleted successfully!"),
              timer: 3000,
            });
            that.getSlots();
          } catch (e) {
            console.log(e);
            swal.fire({
              type: "error",
              title: that.$t("message.Error deleting slot!"),
              timer: 5000,
            });
          }
        });
        window.$(document).one("click", ".cancel", function () {
          swal.close();
        });

        let buttons =
          '<button class="swal2-confirm delete swal2-styled">Delete</button>  <button class="cancel swal2-cancel swal2-styled">Cancel</button>';
        if (schedule[0].seriesId) {
          buttons =
            '<button class="btn btn-danger delete">Delete Occurance</button> <button class="btn btn-danger delete-series">Delete Series</button> <button class="btn btn-info cancel">Cancel</button>';
        }

        swal.fire({
          type: "warning",
          title: this.$t("message.Are you sure?"),
          html:
            "<div" +
            "You will not be able undo this action" +
            "<br> <br> <br> <br>" +
            buttons +
            "</div>",
          showConfirmButton: false,
        });
      });

      //Update schedule
      this.$refs.calendar.registerEvent("beforeUpdateSchedule", (e) => {
        console.log(e);
        e.schedule.start = e.schedule.start._date;
        e.schedule.end = e.schedule.end._date;
        this.openAvailibilityModal("update", e);
      });

      this.getSlots();
    },
    setAvailabilityLocation(id, name) {
      this.availabilityLocation = { id, name };
      console.log(this.availabilityLocation);
    },
    async getSlots() {
      this.scheduleData = await this.$store.dispatch("getSlots", this.user._id);

      try {
        let cal = this.$refs.calendar.calendar;
        this.apptDateDetails = {
          dateStart: moment(cal._renderRange.start._date)
            .startOf("day")
            .valueOf(),
          dateEnd: moment(cal._renderRange.end._date).endOf("day").valueOf(),
        };

        let options = {
          doctorId: this.user._id,
          dateDetails: this.apptDateDetails,
          POSTPONED_APPOINTMENTS: true,
          statusCheckArray: [
            "Created",
            "Assigned",
            "InProgress",
            "Closed",
            "Completed",
            "Declined",
            "Cancelled",
            "Postponed",
          ],
          appointmentType: "Scheduled",
          pageSize: 20,
          pageNumber: 1,
        };

        let response = await this.$store.dispatch(
          "getCompletedAppointments",
          options
        );

        this.appointments = [];

        for (let index = 0; index < response.totalPages; index++) {
          options.pageNumber = index + 1;
          this.appointments.push(
            ...(await this.$store.dispatch("getCompletedAppointments", options))
              .data
          );
        }
      } catch (e) {
        console.log(e);
      }

      this.setSchedules();
      this.setRenderRangeText();
    },
    setSchedules() {
      let that = this;
      this.$refs.calendar.fireMethod("clear");
      var schedules = [];
      if (this.scheduleData) {
        schedules = this.scheduleData.map(function (s) {
          return {
            bgColor: that.getColor(s.type, "bgColor"),
            borderColor: that.getColor(s.type, "borderColor"),
            calendarId: s.type,
            color: that.getColor(s.type, "color"),
            dragBgColor: that.getColor(s.type, "dragBgColor"),
            dueDateClass: "",
            end: s.isAllDay
              ? moment(s.end).format("YYYY-MM-DD HH:mm:SS")
              : s.end,
            start: s.isAllDay
              ? moment(s.start).format("YYYY-MM-DD HH:mm:SS")
              : s.start,
            seriesId: s.seriesId,
            id: s.slotId,
            isAllDay: s.isAllDay,
            category: s.isAllDay ? "allday" : "time",
            location: s.location && s.location.name ? s.location.name : "",
            raw: { class: "public" },
            state: "Free",
            title: s.description,
            isReadOnly: s.type === "Holiday" ? true : false,
          };
        });

        this.schedules = schedules;
      }

      if (this.appointments && this.appointments.length > 0) {
        for (var h in this.appointments) {
          schedules.push({
            color: this.getColor(
              this.getCalId(this.appointments[h].latestStatus),
              "color"
            ),
            bgColor: this.getColor(
              this.getCalId(this.appointments[h].latestStatus),
              "bgColor"
            ),
            borderColor: this.getColor(
              this.getCalId(this.appointments[h].latestStatus),
              "borderColor"
            ),
            calendarId: this.getCalId(this.appointments[h].latestStatus),
            dueDateClass: "",
            start: parseInt(this.appointments[h].scheduledTimestamp.start),
            end: parseInt(this.appointments[h].scheduledTimestamp.end),
            seriesId: null,
            id: h._id,
            isAllDay: false,
            category: "time",
            location: "",
            raw: { class: "public" },
            state: "Busy",
            title:
              "With " +
              this.appointments[h].patient.firstName +
              " " +
              this.appointments[h].patient.lastName +
              " -- " +
              this.appointments[h].latestStatus,
            isReadOnly: true,
          });
        }
      }
    },
    getTimeTemplate(schedule, isAllDay) {
      let html = [];
      let start = moment(schedule.start.toUTCString());
      if (!isAllDay) {
        html.push("<strong>" + start.format("hh:mm A") + "</strong> ");
      }
      if (schedule.isPrivate) {
        html.push('<span class="calendar-font-icon ic-lock-b"></span>');
        html.push(" Private");
      } else {
        if (schedule.isReadOnly) {
          html.push('<span class="calendar-font-icon ic-readonly-b"></span>');
        } else if (schedule.recurrenceRule) {
          html.push('<span class="calendar-font-icon ic-repeat-b"></span>');
        } else if (schedule.attendees.length) {
          html.push('<span class="calendar-font-icon ic-user-b"></span>');
        } else if (schedule.location) {
          html.push('<span class="calendar-font-icon ic-location-b"></span>');
        }
        html.push(" " + schedule.title);
      }

      return html.join("");
    },
    getColor(calendarId, colorType) {
      for (var index in this.calendarList) {
        if (this.calendarList[index].id === calendarId)
          return this.calendarList[index][colorType];
      }
    },
    setRenderRangeText() {
      var options = this.$refs.calendar.fireMethod("getOptions");
      var viewName = this.$refs.calendar.fireMethod("getViewName");

      if (viewName === "day") {
        this.range = moment(
          this.$refs.calendar.fireMethod("getDate").getTime()
        ).format("DD-MM-YYYY");
      } else if (
        viewName === "month" &&
        (!options.month.visibleWeeksCount ||
          options.month.visibleWeeksCount > 4)
      ) {
        this.range = moment(this.$refs.calendar.fireMethod("getDate")).format(
          "MMM, YYYY"
        );
      } else {
        this.range =
          moment(
            this.$refs.calendar.fireMethod("getDateRangeStart").getTime()
          ).format("DD-MM-YYYY") +
          " ~ " +
          moment(
            this.$refs.calendar.fireMethod("getDateRangeEnd").getTime()
          ).format("DD-MM-YYYY");
      }
    },
    setRange(command) {
      this.$refs.calendar.fireMethod(command);

      this.setRenderRangeText();
      this.setSchedules();
    },
    openAvailibilityModal(mode, scheduleData) {
      this.SHOW_AVAILABILITY_MODAL = true;

      this.availabilitySaveMode = mode || "create";
      this.availabilityScheduleData = scheduleData || null;

      if (
        scheduleData &&
        scheduleData.schedule &&
        scheduleData.schedule.isAllDay
      ) {
        scheduleData.schedule.start.setHours(this.workingHours.start);
        scheduleData.schedule.start.setMinutes(0);
        scheduleData.schedule.end.setHours(this.workingHours.end - 1);
        scheduleData.schedule.end.setMinutes(59);
      }
    DatePicker.localeTexts['calendarLanguage'] = this.calendarLanguageObject();

      this.startDatePicker = new DatePicker("#start-wrapper", {
      language: "calendarLanguage",
        date:
          scheduleData && scheduleData.schedule && scheduleData.schedule.start
            ? scheduleData.schedule.start
            : new Date(),
        input: {
          element: "#start-date",
          format: "dd-MM-yyyy HH:mm A",
        },
        timepicker: {
          showMeridiem: true,
        },
      });

      this.endDatePicker = new DatePicker("#end-wrapper", {
      language: "calendarLanguage",
        date:
          scheduleData && scheduleData.schedule && scheduleData.schedule.end
            ? scheduleData.schedule.end
            : new Date(),
        input: {
          element: "#end-date",
          format: "dd-MM-yyyy HH:mm A",
        },
        timepicker: {
          showMeridiem: true,
        },
      });

      this.repeatEvery = 1;
      this.daysOfWeek = [];

      this.daysOfWeek = ["MO", "TU", "WE", "TH"];
      this.frequency = null;
    },
    async saveAvailability() {
      let that = this;
      this.SHOW_AVAILABILITY_MODAL = false;
      if (this.startDatePicker.getDate() > this.endDatePicker.getDate()) {
        swal.fire({
          type: "error",
          title: that.$t("message.Start date time is after end date time!"),
          timer: 5000,
        });
      } else {
        if (this.availabilitySaveMode == "update") {
          console.log(
            "availabilityScheduleData",
            this.availabilityScheduleData
          );
          // this.availabilityScheduleData.schedule.start = this.availabilityScheduleData.start;
          // this.availabilityScheduleData.schedule.end = this.availabilityScheduleData.end;

          this.availabilityScheduleData.calendar = this.calendarList.find(
            function (c) {
              return c.id === that.availabilityScheduleData.schedule.calendarId;
            }
          );
          let slotForUpdate = {
            type: this.availabilityType,
            description: this.availabilityType,
            end: this.endDatePicker.getDate().getTime(),
            start: this.startDatePicker.getDate().getTime(),
            isAllDay: this.allDay,
            slotId: this.availabilityScheduleData.schedule.id,
            seriesId: this.availabilityScheduleData.schedule.seriesId
              ? this.availabilityScheduleData.schedule.seriesId
              : null,
          };
          if (
            this.availabilityLocation &&
            slotForUpdate.type != "Available-TeleConsult"
          )
            slotForUpdate["location"] = this.availabilityLocation;
          try {
            await this.$store.dispatch("updateSlot", slotForUpdate);
            swal.fire({
              type: "success",
              title: this.$t("message.Slot updated successfully!"),
              timer: 3000,
            });
            this.getSlots();
          } catch (e) {
            console.log(e);
            swal.fire({
              type: "error",
              title: this.$t("message.Error updating slot!"),
              timer: 5000,
            });
          }
        } else {
          let availability = {
            bgColor:
              this.availabilityType == "Available"
                ? "#bbdc00"
                : this.availabilityType == "Available-TeleConsult"
                ? "#d2db9e"
                : "#7a8f06",
            borderColor: "#bbdc00",
            calendarId: this.availabilityType,
            category: "time",
            color: "#ffffff",
            dragBgColor: "#bbdc00",
            dueDateClass: "",
            end: tuiCalendar.getTZDate(this.endDatePicker.getDate()),
            id: String(chance.guid()),
            isAllDay: this.allDay,
            location: "",
            name: this.availabilityType,
            raw: { class: "public" },
            start: tuiCalendar.getTZDate(this.startDatePicker.getDate()),
            state: "Busy",
            title: this.availabilityType,
            recurrence:
              !this.frequency || this.frequency == "NEVER"
                ? null
                : {
                    frequency: this.frequency,
                    startDate: moment
                      .utc(this.startDatePicker.getDate())
                      .format("YYYYMMDD"),
                    endDate: moment
                      .utc(this.endDatePicker.getDate())
                      .format("YYYYMMDD"),
                    daysOfWeek: this.daysOfWeek,
                    startTime: moment(this.startDatePicker.getDate()).format(
                      "HHmm"
                    ),
                    endTime: moment(this.endDatePicker.getDate()).format(
                      "HHmm"
                    ),
                  },
          };

          if (
            availability.recurrence &&
            availability.recurrence.startTime > availability.recurrence.endTime
          ) {
            swal.fire({
              type: "error",
              title: that.$t("message.Start time is after end time!"),
              timer: 5000,
            });
          } else {
            this.saveNewSchedule(availability);
          }
        }
      }
    },
    selectDay(day) {
      if (this.daysOfWeek.includes(day)) {
        if (this.daysOfWeek.length > 1) {
          this.daysOfWeek.splice(this.daysOfWeek.indexOf(day), 1);
        }
      } else {
        this.daysOfWeek.push(day);
      }
    },
    async saveNewSchedule(scheduleData) {
      let that = this;
      var calendar = this.calendarList.filter(function (c) {
        return c.id === scheduleData.calendarId;
      })[0];
      var schedules = [];
      var recurrence = scheduleData.recurrence;
      if (!recurrence) {
        var schedule = {
          id: String(chance.guid()),
          title: scheduleData.title || calendar.name,
          isAllDay: scheduleData.isAllDay,
          start: scheduleData.start,
          end: scheduleData.end,
          category: scheduleData.isAllDay ? "allday" : "time",
          dueDateClass: "",
          location: scheduleData.location,
          raw: {
            class: scheduleData.raw["class"],
          },
          state: scheduleData.state,
        };
        if (calendar) {
          schedule.name = calendar.name;
          schedule.calendarId = calendar.id;
          schedule.color = calendar.color;
          schedule.bgColor = calendar.bgColor;
          schedule.dragBgColor = calendar.bgColor;
          schedule.borderColor = calendar.borderColor;
        }
        schedules.push(schedule);
      } else {
        var rruleObj = {
          freq: RRule[recurrence["frequency"]],
          interval: recurrence["interval"] || 1,
          dtstart: new Date(
            Date.UTC(
              parseInt(recurrence["startDate"].substring(0, 4)),
              parseInt(recurrence["startDate"].substring(4, 6)) - 1,
              parseInt(recurrence["startDate"].substring(6, 8))
            )
          ),
        };
        if (recurrence["tzid"]) {
          rruleObj["tzid"] = recurrence["tzid"];
        }
        if (recurrence["endDate"]) {
          rruleObj["until"] = new Date(
            Date.UTC(
              parseInt(recurrence["endDate"].substring(0, 4)),
              parseInt(recurrence["endDate"].substring(4, 6)) - 1,
              parseInt(recurrence["endDate"].substring(6, 8))
            )
          );
        } else if (recurrence["count"]) {
          rruleObj["count"] = recurrence["count"];
        }
        if (recurrence["frequency"] == "WEEKLY" && recurrence["daysOfWeek"]) {
          rruleObj["byweekday"] = recurrence["daysOfWeek"].map(
            (datOfWeek) => RRule[datOfWeek]
          );
        } else if (
          recurrence["frequency"] == "MONTHLY" &&
          recurrence["daysOfMonth"]
        ) {
          rruleObj["bymonthday"] = recurrence["daysOfMonth"];
        }

        var rule = new RRule(rruleObj);
        var slots = rule.all();
        slots = slots.map((date) => {
          var startDateTime = moment(date)
            .local()
            .set("hour", parseInt(recurrence["startTime"].substring(0, 2)))
            .set("minute", parseInt(recurrence["startTime"].substring(2, 4)))
            .toDate();
          var endDateTime = null;
          if (recurrence["endTime"]) {
            endDateTime = moment(date)
              .local()
              .set("hour", parseInt(recurrence["endTime"].substring(0, 2)))
              .set("minute", parseInt(recurrence["endTime"].substring(2, 4)))
              .toDate();
          } else if (recurrence["durationMinutes"]) {
            endDateTime = moment(startDateTime).add(
              parseInt(recurrence["durationMinutes"]),
              "minutes"
            );
          }
          return {
            start: startDateTime,
            end: endDateTime,
          };
        });

        var seriesId = String(chance.guid());
        slots.forEach(function (slot) {
          var schedule = {
            id: String(chance.guid()),
            seriesId: seriesId,
            title: scheduleData.title || calendar.name,
            isAllDay: scheduleData.isAllDay,
            start: slot.start,
            end: slot.end,
            category: scheduleData.isAllDay ? "allday" : "time",
            dueDateClass: "",
            location: scheduleData.location,
            raw: {
              class: scheduleData.raw["class"],
            },
            state: scheduleData.state,
          };
          if (calendar) {
            schedule.name = calendar.name;
            schedule.calendarId = calendar.id;
            schedule.color = calendar.color;
            schedule.bgColor = calendar.bgColor;
            schedule.dragBgColor = calendar.bgColor;
            schedule.borderColor = calendar.borderColor;
          }
          schedules.push(schedule);
        });
      }
      var slotsTosave = schedules.map(function (s) {
        var tempSlot = {
          type: s.name,
          description: s.title,
          end: s.end.getTime(),
          start: s.start.getTime(),
          isAllDay: s.isAllDay,
          slotId: s.id,
          seriesId: s.seriesId ? s.seriesId : null,
        };
        tempSlot.userId = that.user._id;

        if (
          that.availabilityLocation &&
          tempSlot.type != "Available-TeleConsult"
        )
          tempSlot["location"] = that.availabilityLocation;

        return tempSlot;
      });

      try {
        await this.$store.dispatch("saveSlots", slotsTosave);
        swal.fire({
          type: "success",
          title: that.$t("message.Slots saved successfully!"),
          timer: 3000,
        });
        this.getSlots();
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "error",
          title: that.$t("message.Error saving slots!"),
          timer: 5000,
        });
      }
    },
    getCalId(status) {
      for (var c in this.calendarList) {
        if (this.calendarList[c].status.indexOf(status) > -1)
          return this.calendarList[c]["id"];
      }
    },
    getCalanderNameTranslation(lable) {
      if (lable == "Available") {
        return this.$t("message.Available");
      }
      if (lable == "Available-TeleConsult") {
        return this.$t("message.Available-Teleconsult");
      }
      if (lable == "Available-InPerson") {
        return this.$t("message.Available-Inperson");
      }
      if (lable == "Upcoming") {
        return this.$t("message.Upcoming");
      }
      if (lable == "Ongoing") {
        return this.$t("message.Ongoing");
      }
      if (lable == "Completed") {
        return this.$t("message.Completed");
      }
      if (lable == "Cancelled") {
        return this.$t("message.Cancelled");
      } else {
        return lable;
      }
    },
  },

  watch: {
    selectedCalendar: function () {
      let that = this;
      if (this.selectedCalendar == "All") {
        this.calendarList.forEach(function (calendar) {
          calendar.checked = true;
        });
      } else {
        this.calendarList.forEach(function (calendar) {
          if (calendar.id != that.selectedCalendar) {
            calendar.checked = false;
          } else {
            calendar.checked = true;
          }
        });
      }

      this.calendarList.forEach(function (calendar) {
        that.$refs.calendar.fireMethod(
          "toggleSchedules",
          calendar.id,
          !calendar.checked,
          false
        );
      });

      that.$refs.calendar.fireMethod("render", true);
    },
    selectedView: function () {
      this.$refs.calendar.fireMethod("changeView", this.selectedView, true);
      this.getSlots();
    },
  },
};
</script>

<style scoped>
/deep/ .tui-full-calendar-popup-section:nth-child(3) {
  display: none;
}
/deep/
  .tui-full-calendar-popup-section.tui-full-calendar-dropdown.tui-full-calendar-close.tui-full-calendar-section-state {
  display: none;
}

/deep/ .tui-full-calendar-popup-detail-item:nth-child(2) {
  display: none;
}

/deep/ #add-availability-modal {
  position: fixed;
  z-index: 100;
  top: 5em;
}

/deep/ #add-availability-modal .tui-timepicker-select {
  padding-top: 0px;
}

/deep/ .tui-datepicker {
  position: absolute;
}

/* Below code was commented because date picker was not selectable */
/* /deep/ .tui-datepicker-type-date {
  display: none;
} */

/deep/ .tui-timepicker-select {
  border-radius: 10em;
}
</style>

<style>
:focus-visible {
  outline: -webkit-focus-ring-color auto 0px;
}
</style>
